
import logo from "../../assets/images/logosmall.png"

export default function AppSplash({ text = "Loading..." }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-white/90 backdrop-blur-md dark:bg-neutral-950/90">
      <div className="flex flex-col items-center gap-4">
        <img
          src={logo}
          alt="Logo"
          className="h-14 w-auto select-none"
          draggable={false}
        />

        <div className="flex items-center gap-3 mt-3">
          <span className="h-5 w-5 rounded-full border-2 border-black/20 border-t-black dark:border-t-white animate-spin" />
          <span className="text-xs text-black/70 dark:text-white/70">{text}</span>
        </div>
      </div>
    </div>
  );
}
